export function getName(container) {
    return container.name;
}
export function getMappingId(container) {
    return container.mappingId;
}
export function getDefinitionKey(container) {
    return container.definitionKey;
}
export function getItemMappingIds(container) {
    return container.itemMappingIds;
}
export function getInfusedItemMappingIds(container) {
    return container.infusedItemMappingIds;
}
export function hasInfusions(container) {
    return container.hasInfusions;
}
export function getContainerType(container) {
    return container.containerType;
}
export function isShared(container) {
    return container.isShared;
}
export function getWeightInfo(container) {
    return container.weightInfo;
}
export function isEquipped(container) {
    return container.isEquipped;
}
export function getCoin(container) {
    return container.coin;
}
export function getItem(container) {
    return container.item;
}
